import React from "react";
import { Typography, TypographyProps } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";

type ListingModalOptionTitleProps = TypographyProps;

export const ListingModalOptionTitle = ({
  children,
  sx,
  ...props
}: ListingModalOptionTitleProps) => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <Typography
      sx={{
        color: colors.surface.onSurface,
        ...sx,
      }}
      variant={"body2"}
      {...props}
    >
      {children}
    </Typography>
  );
};
